import { IconCalendar } from "@tabler/icons-react";
import { useStatusStore } from "@/utils/stores/useStatusStore";
import FilterChipsGroup from "@pages/TaxProClientList/components/advancedFilters/FilterChipsGroup/FilterChipsGroup";
import FilterChip from "@pages/TaxProClientList/components/advancedFilters/FilterChip/FilterChip";
import "./TaxYearFilter.scss";

interface TaxYearFilterProps {
  availableTaxYears: number[];
  isLoading: boolean;
}

const TaxYearFilter = ({
  availableTaxYears,
  isLoading,
}: TaxYearFilterProps) => {
  const { selectedTaxYear, setSelectedTaxYear } = useStatusStore();

  const handleYearClick = (year: number | null) => {
    setSelectedTaxYear(year);
  };

  return (
    <FilterChipsGroup data-testid="tax-year-filter">
      <FilterChip
        isActive={selectedTaxYear === null}
        color="#0077CC"
        icon={<IconCalendar size={14} />}
        onChange={() => handleYearClick(null)}
        disabled={isLoading}
        borderWidth={1}
        customStyles={{
          label: {
            paddingLeft: "16px",
            paddingRight: "16px",
          },
        }}
      >
        All Years
      </FilterChip>
      {(availableTaxYears || []).map((year) => (
        <FilterChip
          key={year}
          isActive={selectedTaxYear === year}
          color="#0077CC"
          onChange={() => handleYearClick(year)}
          disabled={isLoading}
          borderWidth={1}
          customStyles={{
            label: {
              paddingLeft: "16px",
              paddingRight: "16px",
            },
          }}
        >
          {year}
        </FilterChip>
      ))}
    </FilterChipsGroup>
  );
};

export default TaxYearFilter;
